import React from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { InputNumberWrapper } from './styles';
import * as S from './styles';

export function RpnFormItemInitial() {
	return (
		<Col span={11}>
			<S.CustomFormItem label={I18n.get('RPN')} name="min_rpn">
				<InputNumberWrapper min={0} placeholder="0" name="min" />
			</S.CustomFormItem>
		</Col>
	);
}
